import { Rating, Stack, Text } from '@mantine/core';

import { useLocal } from '../../lib/local/use-local';
import { Feedback } from './add_order_feedback.request';
import { GradeTitleValue, selectTitleGrade } from './grade-title';

const GradeDescription = ({ value = 0 }: { value?: GradeTitleValue }) => {
  useLocal();

  return <span style={{ fontWeight: 500 }}>{selectTitleGrade(value)}</span>;
};

type DisplayFeedbackProps = {
  feedback: Omit<Feedback, 'id' | 'orderId' | 'date'> | null | undefined;
  hideMessage?: boolean;
};

export const DisplayFeedback = ({ feedback }: DisplayFeedbackProps) => {
  if (!feedback) return null;
  return (
    <Stack justify="center" align="center" spacing={8}>
      <Rating
        count={5}
        // @ts-expect-error 'size' is also support number
        size={40}
        readOnly
        value={feedback.rating}
      />

      <GradeDescription value={feedback.rating as GradeTitleValue} />

      {feedback.description && (
        <Text mt={16} size="md" w="100%">
          {feedback.description}
        </Text>
      )}
    </Stack>
  );
};
